/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { CaloriesUpdateRequest } from "../models/CaloriesUpdateRequest";
import type { DataResponse_CaloriesResponse_ } from "../models/DataResponse_CaloriesResponse_";
import type { DataResponse_MacrosResponse_ } from "../models/DataResponse_MacrosResponse_";
import type { MacrosUpdateRequest } from "../models/MacrosUpdateRequest";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class NutritionalRequirementsService {
  /**
   * Get Calories
   * Get daily and weekly calorie targets.
   * @param xUserId
   * @returns DataResponse_CaloriesResponse_ Successful Response
   * @throws ApiError
   */
  public static getCaloriesApiV1NutritionalRequirementsCaloriesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_CaloriesResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/nutritional-requirements/calories",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Calories
   * Update daily calorie target (preserves macro percentages).
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateCaloriesApiV1NutritionalRequirementsCaloriesPut(
    xUserId: string,
    requestBody: CaloriesUpdateRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/nutritional-requirements/calories",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Macros
   * Get daily macro percentages and grams.
   * @param xUserId
   * @returns DataResponse_MacrosResponse_ Successful Response
   * @throws ApiError
   */
  public static getMacrosApiV1NutritionalRequirementsMacrosGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_MacrosResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/nutritional-requirements/macros",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Macros
   * Update macro percentages (validates sum = 100%).
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateMacrosApiV1NutritionalRequirementsMacrosPut(
    xUserId: string,
    requestBody: MacrosUpdateRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/nutritional-requirements/macros",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
